"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gen_run_newLevel = void 0;
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var battlescapeMap_sidecar_1 = require("../levelgen/battlescapeMap-sidecar");
var minigolfGen_level_sidecar_1 = require("../levelgen/minigolfGen_level-sidecar");
var minigolfGameState_1 = require("./minigolfGameState");
var minigolfGameState_sidecar_1 = require("./minigolfGameState-sidecar");
function gen_run_newLevel() {
    var map;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                minigolfGameState_sidecar_1.minigolfGameState.get().state = minigolfGameState_1.MinigolfGameStates.levelGen;
                map = minigolfGameState_sidecar_1.minigolfGameState.get().map;
                if (!map) {
                    map = battlescapeMap_sidecar_1.battlescapeMap.create(minigolfDefs_sidecar_1.minigolfDefs.widthInSections, minigolfDefs_sidecar_1.minigolfDefs.heightInSections);
                    minigolfGameState_sidecar_1.minigolfGameState.get().map = map;
                }
                minigolfGameState_sidecar_1.minigolfGameState.get().playerState.gameStateString = 'Generating level';
                return [5 /*yield**/, __values(minigolfGen_level_sidecar_1.minigolfGen_level.gen_test(map))];
            case 1:
                _a.sent();
                return [2 /*return*/, 0];
        }
    });
}
exports.gen_run_newLevel = gen_run_newLevel;
